/**
 * @file: 初始化SDK
 */
import { AppMetadata, prefetchApps } from 'qiankun';
import { FInitialConfig, FPageConfig, TPlatforms } from '../typings/index';
import store from '../store/index';
import getHttpInstance from './gwApi';
import { baseGatewayApi, getAppEntryFromConfig} from '../config/index';
import { AxiosResponse } from 'axios';

export default async function(config: FInitialConfig) {
  // 注入 APP_ID 识别当前所属的应用类型
  // 初始化 tam 的日志
  // 拉取后台的配置信息
  // https://uni.xiaowei.cloud.tencent.com/api/common/getTestSign
  const isDEV = config.mode === 'development';
  await store.dispatch({
    type: 'SET',
    payload: {
      path: 'mode',
      data: config.mode,
    }
  });
  const instance = getHttpInstance(config.signUrl, isDEV);
  const res: AxiosResponse<FPageConfig> = await instance.request({
    method: 'GET',
    baseURL: baseGatewayApi,
    url: isDEV ? '/test/api/app' : '/api/app',
    params: {
      appId: config.app_id,
    }
  });
  if (res.status === 200) {
    let isAccess = false;
    if (res?.data?.platform === TPlatforms.INDUSTRY_PLATFORM) {
      const info: FPageConfig[] = store.getState().get(TPlatforms.INDUSTRY_PLATFORM) as any;
      store.dispatch({
        type: 'SET',
        payload: {
          path: TPlatforms.INDUSTRY_PLATFORM,
          data: [...info, res?.data],
        }
      });
      isAccess = true;
    } else if (res?.data?.platform === TPlatforms.SMART_CONTACT_CMS) {
      const info: FPageConfig[] = store.getState().get(TPlatforms.SMART_CONTACT_CMS) as any;
      store.dispatch({
        type: 'SET',
        payload: {
          path: TPlatforms.SMART_CONTACT_CMS,
          data: [...info, res?.data],
        }
      });
      isAccess = true;
    }
    // 进行样式补充，避免
    document.body.style.cssText = 'display: block !important;'
    if (res.data && config.prefetch && isAccess) {
      // 进行预加载进行提速
      console.log('启动预加载');
      const entrys: AppMetadata[] = [getAppEntryFromConfig(res.data, config.mode)] as AppMetadata[];
      prefetchApps(entrys)
    }
    if (!isAccess) {
      return Promise.reject(new Error('当前页面尚未接入APAAS模式，请联系Harkinli'));
    }
    return res.data;
  } else {
    let errMsg = '';
    if (res.status !== 200) {
      errMsg = `network error: ${res.status}`;
    } else {
      errMsg = `后台请求错误：${'服务器错误'}`;
    }
    return Promise.reject(new Error(errMsg));
  }
}
